import { ModalWindow } from '@components/Modal/ModalWindow';
import { ModalWindowContent } from '@components/Modal/ModalWindowContent';
import { ModalWindowTitle } from '@components/Modal/ModalWindowTitle';
import { useData } from '@hooks/useData';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { IModalWindow } from '@hooks/useModalWindow';
import { IExcedenteItem } from '@model/ExcedenteItem';
import { useExcedenteService } from '@services/ExcedenteService';
import React from 'react';
import { ExcedenteDetalheTable } from './ExcedenteDetalheTable';

export type ExcedenteDetalheModalProps = {
    excedenteId: number
    modal: IModalWindow
}

export function ExcedenteDetalheModal ({ excedenteId, modal }: ExcedenteDetalheModalProps) {
    const loading = useLoading();
    const message = useMessage();

    const excedenteService = useExcedenteService();

    const data = useData<IExcedenteItem>();

    const handleEnter = React.useCallback(() => {
        if (!loading.isLoading) {
            loading.start();
            excedenteService.listarItens(excedenteId)
                .then(data.handleDataResponse)
                .catch(message.showException)
                .finally(loading.stop);
        }
    }, [data.handleDataResponse, excedenteId, excedenteService, loading, message.showException]);

    return (
        <ModalWindow
            modal={modal}
            disabled={loading.isLoading}
            size="md"
            TransitionProps={{
                onEnter: handleEnter
            }}
        >
            <ModalWindowTitle title={`Itens do Excedente ${excedenteId}`} />

            <ModalWindowContent>
                <ExcedenteDetalheTable 
                    data={data}
                />
            </ModalWindowContent>
        </ModalWindow>
    )
}